export default "__VITE_ASSET___$ABkEFe__"